import { css } from '@emotion/react';
import type { WatcherState } from '../../../../constants/redLightGreenLightConfig';

export const gameWrapperStyle = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
`;

export const redLightGameAreaStyle = css`
  position: relative;
  width: 100%;
  flex: 1;
  background: #e8dcc8;
  overflow: hidden;
  border-radius: 12px;
`;

export const backgroundStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
`;

export const decorationStyle = (x: number, y: number, size: number) => css`
  position: absolute;
  left: ${x}px;
  top: ${y}px;
  width: ${size}px;
  height: ${size}px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 1.5;
  opacity: 0.8;
  pointer-events: none;
`;

export const watcherStyle = (x: number, y: number, _state: WatcherState) => css`
  position: absolute;
  left: ${x}px;
  top: ${y}px;
  width: 150px;
  height: 150px;
  transform: translate(-50%, -50%);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 2;
`;

export const playerStyle = (x: number, y: number, caught: boolean) => css`
  position: absolute;
  left: ${x}px;
  top: ${y}px;
  width: 100px;
  height: 100px;
  transform: translate(-50%, -50%);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 3;

  ${
    caught
      ? `
    animation: shake 0.5s ease-in-out;
    @keyframes shake {
      0%, 100% { transform: translate(-50%, -50%) translateX(0); }
      25% { transform: translate(-50%, -50%) translateX(-10px); }
      75% { transform: translate(-50%, -50%) translateX(10px); }
    }
  `
      : ''
  }
`;
